export function formatFullTimestamp(date: Date = new Date()): string {
  try {
    return date.toLocaleString(undefined as any, {
      dateStyle: 'full',
      timeStyle: 'long',
      timeZoneName: 'short',
    } as any);
  } catch (_) {
    try {
      return date.toLocaleString();
    } catch (__) {
      return date.toISOString();
    }
  }
}

export function formatLongDate(date: Date): string {
  try {
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch (_) {
    try {
      return date.toLocaleDateString();
    } catch (__) {
      return date.toISOString().slice(0, 10);
    }
  }
}





